import { Pipe, PipeTransform } from '@angular/core';
import {PreferenceService} from '../services/preference.service';

@Pipe({
  standalone: false,
  name: 'tempSplit'
})
export class TempSplitPipe implements PipeTransform {
  constructor(private preferenceService: PreferenceService) {}

  transform(value: any, args?: any): any {
    if (this.preferenceService.tempUnit === '℉') {
      if (typeof value === 'string' && value.search('/')) {
        const tempArr = value.split('/ ');
        const tempCal = tempArr.map((temp) => {
          const parsed = parseFloat(temp);
          if (!isNaN(parsed)) {
            return ((parsed * 1.8) + 32).toFixed(1);
          }
          return temp;
        });
        return tempCal.join('/ ');
      } else {
        const parsed = parseFloat(value);
        if (!isNaN(parsed)) {
          return ((parsed * 1.8) + 32).toFixed(1);
        }
      }
    }
    return value;
  }

   checkIsNumber(input) {
    const re = /^[0-9] .?[0-9]*/; // 判斷正整數/[1−9] [0−9]∗]∗/
    if (!re.test(input)) {
      return true;
    }
    return false;
  }

}
